var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYaPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.8A5.8 5.8 0 1 0 7 1.2a5.8 5.8 0 0 0 0 11.6ZM7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.988 11.206h1.463v-8.4H7.324c-2.14 0-3.264 1.1-3.264 2.72 0 1.293.617 2.054 1.717 2.84l-1.91 2.84H5.45l2.128-3.178-.738-.496c-.894-.604-1.33-1.076-1.33-2.09 0-.895.63-1.5 1.826-1.5h.652v7.264Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaPay);
export default __webpack_public_path__ + "static/media/yaPay.6f9f91d91d31c0285ff4e6c2e4fb1dd3.svg";
export { ForwardRef as ReactComponent };